module.exports = __webpack_public_path__ + "static/media/bd1075.d2df9c25.mp3";